/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * @returns All feature flags
 */
// eslint-disable-next-line import/prefer-default-export
export function useFeatureFlags() {
    // Converted to generic type so typescript consumers don't need to reference LDFlagSet type.
    // Avoids TSError: 'Cannot find module 'launchdarkly-js-sdk-common' or its corresponding type declarations.'
    return useFlags() as { [key: string]: any };
}
